import {signal} from '@preact/signals';
import { ImageState } from '@/otp-gifts/types'


const carouselImages = signal<ImageState[]>([]);

export default class CarouselImagesSignal {

  setImages = (images: ImageState[]) => {
    if(images?.length) {
        carouselImages.value = images
    }
  }

  getImages = () => {
    return carouselImages.value
  }
}
